"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ItemResponses;
(function (ItemResponses) {
    var ListContentItemsResponse = /** @class */ (function () {
        /**
        * Response containing multiple item
        * @constructor
        * @param {TItem[]} items - Collection of content items
        * @param {Pagination} pagination - Pagination object
        * @param {IContentItemsContainer} linkedItems - Content items that were processed during request
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function ListContentItemsResponse(items, pagination, linkedItems, debug) {
            this.items = items;
            this.pagination = pagination;
            this.linkedItems = linkedItems;
            this.debug = debug;
            this.isEmpty = this.getIsEmpty();
            this.lastItem = this.getLastItem();
            this.firstItem = this.getFirstItem();
        }
        ListContentItemsResponse.prototype.getIsEmpty = function () {
            if (!this.items) {
                return true;
            }
            return this.items.length <= 0;
        };
        ListContentItemsResponse.prototype.getFirstItem = function () {
            if (!this.items) {
                return;
            }
            if (this.items.length < 1) {
                return;
            }
            return this.items[0];
        };
        ListContentItemsResponse.prototype.getLastItem = function () {
            if (!this.items) {
                return;
            }
            if (this.items.length < 1) {
                return;
            }
            return this.items[this.items.length - 1];
        };
        return ListContentItemsResponse;
    }());
    ItemResponses.ListContentItemsResponse = ListContentItemsResponse;
    var ViewContentItemResponse = /** @class */ (function () {
        /**
        * Response containing single item
        * @constructor
        * @param {TItem} item - Returned item
        * @param {IContentItemsContainer} linkedItems - Content items that were processed during request
        * @param {ICloudResponseDebug} debug - Debug information from the request
        */
        function ViewContentItemResponse(item, linkedItems, debug) {
            this.item = item;
            this.linkedItems = linkedItems;
            this.debug = debug;
            this.isEmpty = this.getIsEmpty();
        }
        ViewContentItemResponse.prototype.getIsEmpty = function () {
            if (!this.item) {
                return true;
            }
            return false;
        };
        return ViewContentItemResponse;
    }());
    ItemResponses.ViewContentItemResponse = ViewContentItemResponse;
})(ItemResponses = exports.ItemResponses || (exports.ItemResponses = {}));
//# sourceMappingURL=responses.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/models/item/responses.js